import React, {useState, useEffect} from 'react';
import {IonIcon, IonItem, IonImg, IonButton, IonLabel} from "@ionic/react";
import {cameraOutline} from "ionicons/icons";
import {FileInputProps} from "./index";
import {Camera, CameraResultType, Photo} from "@capacitor/camera";
import styles from './styles.module.css';
import classNames from "classnames";

interface FileInputMobileProps extends FileInputProps {

}

const FileInputMobile: React.FC<FileInputMobileProps> = (props) => {
  const {state} = props;
  const {value} = state;
  const [image, setImage] = useState<Photo>();
  const [imageSrc, setImageSrc] = useState<string>();

  const onClick = async () => {
    let newImage: Photo;
    const defaultOptions = {
      quality: 85,
      allowEditing: false,
      correctOrientation: true,
      resultType: CameraResultType.Uri,
      saveToGallery: false,
      promptLabelHeader: 'Fotos',
      promptLabelCancel: 'Cancelar' ,
      promptLabelPhoto: 'Abrir galeria',
      promptLabelPicture: 'Tirar foto',
    }
    try {
      newImage = await Camera.getPhoto({
        ...defaultOptions,
      });
    } catch (e) {
      // cancelado
      return;
    }

    setImage(newImage);
    props.onChange(props.definition.name, newImage);
  }

  // set imagSrc
  useEffect(() => {
    if (image) {
      setImageSrc(image.webPath);
    } else {
      setImageSrc('');
    }
  }, [image, value]);

  return (
    <div className="flex flex-col w-full">
      <IonItem
        disabled={props.disabled}
        lines="full"
      >
        <IonLabel
          position={props.labelPosition || 'floating'}
        >
          <span className={(props.state.touched && props.state.hasError) ? "text-red-600" : ""}>
            {props.definition.label} {props.definition.required && '*'}
          </span>
        </IonLabel>

        <div className="flex w-full items-center mt-8 mb-2">
          <div className="flex-grow">
            {imageSrc &&
              <div className={classNames(styles.previewMobile, "p-1 rounded bg-pal-dark")}>
                <IonImg
                  src={imageSrc}
                />
              </div>
            }
          </div>

          <div>
            <IonButton
              color="medium"
              fill="outline"
              size="large"
              className="app-button"
              onClick={onClick}
            >
              <IonIcon icon={cameraOutline} slot="icon-only"/>
            </IonButton>
          </div>
        </div>
      </IonItem>
    </div>
  );
}

export default FileInputMobile;
